export default "/static/build/bundle-training-kit.png";